window.sampleSetInputMaterialChanged = () => {
    sampleSetUpdateLibraryPreparation();
    sampleSetUpdateDilutionBuffer();
}

window.sampleSetPlatformChanged = () => {
    sampleSetUpdateLibraryPreparation();
    sampleSetShowConditionalFields();
}

window.sampleSetInitialise = () => {
    sampleSetShowConditionalFields();
    showClinical();
}

window.sampleSetSpeciesChanged = () => {
    showClinical();
}

window.sampleSetShowConditionalFields = () => {
    $(".conditional").hide()
    platform = $('#sample_set_platform :selected').text().toLowerCase();
    $(".conditional.".concat(platform)).show()
}

window.sampleSetUpdateLibraryPreparation = () => {
    stype = $('#sample_set_sample_type :selected').text();
    platform = $('#sample_set_platform :selected').text().toLowerCase();
    lp = $('#sample_set_library_preparation')
    lp.empty()
    lp.append(new Option(''));
    for (i = 0; i < lp_protocols.length; ++i) {
        if ( lp_protocols[i][0] == 'protocol-'.concat(platform) &&
                lp_protocols[i][1] == stype ) {
            lp.append(new Option(lp_protocols[i][2]));
        }
    }
}

window.sampleSetUpdateDilutionBuffer = () => {
    stype = $('#sample_set_sample_type :selected').text();
    ssdb  = $('#sample_set_sample_dilution_buffer');
    ssdb.empty();
    ssdb.append(new Option(''));
    for (i = 0; i < dilution_buffers.length; ++i) {
        if (dilution_buffers[i][0] == stype) {
            ssdb.append(new Option(dilution_buffers[i][1]));
        }
    }
}

window.metagenomic = (ssmt) => {
        sg=document.getElementById("species_group");
        if (ssmt.checked) {
            sg.style.display="none";
        } else {
            sg.style.display="";
        }
}

window.showClinical = () => {
    var hs = 'Homo sapiens'
    var cg = $('#clinical_group')
    if ($('#sample_set_species_id :selected').text() == hs) {
        cg.show();
    } else {
        cg.hide();
    }
}
